/** @jsx jsx */
import { ClassNames, jsx } from '@emotion/react';
import AdvantageCardContainer from 'components/AdvantageCardContainer';
import ButtonAnchor from 'components/ButtonAnchor';
import Container from 'components/Container';
import React from 'react';
import { useIntl } from 'react-intl';
import { Advantage } from 'types/Advantage';
import { Application } from 'types/Application';

export interface ServicesDetailUseReasonsProps extends React.HTMLAttributes<HTMLDivElement> {
  application: Application;
  reasons: Advantage[];
}

const ServicesDetailUseReasons = React.forwardRef<HTMLDivElement, ServicesDetailUseReasonsProps>(
  ({ reasons, application }, ref) => {
    const intl = useIntl();
    const { buttons2 } = application;
    return (
      <ClassNames>
        {({ theme }) => (
          <Container maxWidth='lg'>
            <div
              ref={ref}
              css={{
                '@media(min-width: 960px)': {
                  padding: theme.spacing(4, 0),
                },
                alignItems: 'stretch',
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                padding: theme.spacing(2, 0),
                width: '100%',
              }}
            >
              <div css={{ alignItems: 'stretch', display: 'flex', flexDirection: 'column' }}>
                <div
                  css={{
                    ...theme.typography.h2,
                    '@media(min-width: 960px)': {
                      padding: theme.spacing(0, 2),
                    },
                    alignSelf: 'flex-start',
                    marginBottom: theme.spacing(2),
                  }}
                >
                  {intl.formatMessage({
                    defaultMessage: 'Proč bych měl používat AppOn.cloud?',
                    id: 'application.text2',
                  })}
                </div>
                <AdvantageCardContainer
                  advantages={reasons}
                  css={{ '& > div': { background: '#75BA40 !important', maxWidth: 285 } }}
                />
                <div
                  css={{
                    '& > a': { margin: theme.spacing(2, 1) },
                    '@media(min-width: 600px)': {
                      '& > a': { margin: theme.spacing(2) },
                    },
                    '@media(min-width: 960px)': {
                      padding: theme.spacing(4),
                    },
                    alignItems: 'center',
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                  }}
                >
                  {buttons2.map(({ href, text }, idx) => (
                    <ButtonAnchor key={idx.toString()} href={href} css={{ alignSelf: 'flex-start' }}>
                      {text}
                    </ButtonAnchor>
                  ))}
                </div>
              </div>
            </div>
          </Container>
        )}
      </ClassNames>
    );
  },
);

export default ServicesDetailUseReasons;
